import React from 'react';
import { MediaType } from '../../utils/media';
import useMediaModal from '../../hooks/useMediaModal';
import useDisplayMedia from '../../hooks/useDisplayMedia';
import useMediaLayout from '../../hooks/useMediaLayout';
import useOverflowHandler from '../../hooks/useOverflowHandler';
import useMediaUtils from '../../hooks/useMediaUtils';
import useMediaItemRenderer from '../../hooks/useMediaItemRenderer';
// 컴포넌트 임포트
import MediaModal from './components/MediaModal';
import OverflowIndicator from './components/OverflowIndicator';
/**
 * 콘텐츠 미디어 그리드 컴포넌트
 * 
 * 게시물 등의 콘텐츠에 포함된 미디어(이미지, 비디오)를 그리드 형태로 표시
 */ var ContentMediaGrid = function(param) {
    var _param_images = param.images, images = _param_images === void 0 ? [] : _param_images, _param_videos = param.videos, videos = _param_videos === void 0 ? [] : _param_videos, _param_shortFormVideos = param.shortFormVideos, shortFormVideos = _param_shortFormVideos === void 0 ? [] : _param_shortFormVideos, onImageClick = param.onImageClick, onVideoClick = param.onVideoClick, onOverflowClick = param.onOverflowClick, _param_useBuiltInModal = param.useBuiltInModal, useBuiltInModal = _param_useBuiltInModal === void 0 ? true : _param_useBuiltInModal, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className;
    // 미디어 유틸리티 훅
    var mediaUtils = useMediaUtils();
    // 미디어 표시 계산 훅 사용
    var _useDisplayMedia = useDisplayMedia(images, videos, shortFormVideos), allMedia = _useDisplayMedia.allMedia, displayMedia = _useDisplayMedia.displayMedia, hiddenMedia = _useDisplayMedia.hiddenMedia, hiddenCount = _useDisplayMedia.hiddenCount, hiddenNormalVideos = _useDisplayMedia.hiddenNormalVideos, hiddenShortFormVideos = _useDisplayMedia.hiddenShortFormVideos, hiddenImages = _useDisplayMedia.hiddenImages, isComplexMixedMedia = _useDisplayMedia.isComplexMixedMedia, normalVideos = _useDisplayMedia.normalVideos, autoDetectedShortFormVideos = _useDisplayMedia.shortFormVideos, getMediaDisplayType = _useDisplayMedia.getMediaDisplayType;
    // 미디어가 없으면 null 반환
    if (allMedia.length === 0) return null;
    // 미디어 표시 레이아웃 계산 훅 사용
    var _useMediaLayout = useMediaLayout(displayMedia, normalVideos, autoDetectedShortFormVideos, isComplexMixedMedia), optimizedDisplayMedia = _useMediaLayout.optimizedDisplayMedia, gridTemplateClass = _useMediaLayout.gridTemplateClass, getItemPositionClass = _useMediaLayout.getItemPositionClass;
    // 미디어 모달 훅 사용
    var _useMediaModal = useMediaModal(allMedia.length), isModalOpen = _useMediaModal.isModalOpen, activeModalIndex = _useMediaModal.activeModalIndex, openModal = _useMediaModal.openModal, handleCloseModal = _useMediaModal.closeModal, handlePrevImage = _useMediaModal.handlePrevImage, handleNextImage = _useMediaModal.handleNextImage, createPortalRoot = _useMediaModal.createPortalRoot;
    // 오버플로우 핸들러 훅 사용
    var handleOverflowClick = useOverflowHandler(hiddenMedia, hiddenCount, normalVideos, autoDetectedShortFormVideos, images, useBuiltInModal, onOverflowClick, openModal).handleOverflowClick;
    // 미디어 아이템 렌더러 훅 사용
    var renderMediaItem = useMediaItemRenderer().renderMediaItem;
    // 각 미디어 아이템에 대한 클릭 핸들러
    var handleMediaClick = function(media, index, mediaType) {
        if (useBuiltInModal) {
            var originalIndex = allMedia.findIndex(function(originalMedia) {
                return originalMedia === media;
            });
            openModal(originalIndex >= 0 ? originalIndex : 0);
        } else if (mediaType === MediaType.VIDEO && onVideoClick) {
            onVideoClick(media, index);
        } else if (mediaType === MediaType.IMAGE && onImageClick) {
            onImageClick(media, index);
        }
    };
    // 4개 이상의 미디어가 있는 경우 처리
    var hasMoreThanFour = allMedia.length > 4;
    // 표시할 미디어 개수 - 항상 3개까지만 표시하고 4번째는 +N 형태로 표시
    var displayCount = hasMoreThanFour ? 3 : optimizedDisplayMedia.length;
    // 숨겨진 미디어 개수
    var overflowCount = allMedia.length - displayCount;
    return /*#__PURE__*/ React.createElement("div", {
        className: "grid ".concat(gridTemplateClass, " gap-1 mt-3 rounded-xl overflow-hidden ").concat(className)
    }, optimizedDisplayMedia.slice(0, displayCount).map(function(media, index) {
        var isNormalVideo = normalVideos.includes(media);
        var isShortFormVideo = autoDetectedShortFormVideos.includes(media);
        var mediaType = getMediaDisplayType(media);
        var isFirstItem = index === 0;
        var positionClass = getItemPositionClass(index, isNormalVideo, isFirstItem);
        return /*#__PURE__*/ React.createElement(React.Fragment, {
            key: "media-".concat(media, "-").concat(index)
        }, renderMediaItem(media, index, isFirstItem, mediaType, isNormalVideo, isShortFormVideo, positionClass, handleMediaClick));
    }), hasMoreThanFour && /*#__PURE__*/ React.createElement("div", {
        className: getItemPositionClass(3, false, false)
    }, /*#__PURE__*/ React.createElement(OverflowIndicator, {
        hiddenCount: overflowCount,
        hiddenImages: hiddenImages,
        hiddenNormalVideos: hiddenNormalVideos,
        hiddenShortFormVideos: hiddenShortFormVideos,
        onClick: handleOverflowClick
    })), isModalOpen && /*#__PURE__*/ React.createElement(MediaModal, {
        isOpen: isModalOpen,
        allMedia: allMedia,
        activeIndex: activeModalIndex,
        onClose: handleCloseModal,
        onPrev: handlePrevImage,
        onNext: handleNextImage,
        onIndexChange: openModal,
        getMediaType: getMediaDisplayType,
        isMediaShortForm: function(url) {
            return mediaUtils.isMediaShortForm(url, shortFormVideos);
        },
        isMediaNormalVideo: function(url) {
            return mediaUtils.isMediaNormalVideo(url, videos, shortFormVideos);
        },
        createPortalRoot: createPortalRoot
    }));
};
export default ContentMediaGrid;
